import { render, staticRenderFns } from "./RadioVcDemo.vue?vue&type=template&id=fc24e59e&scoped=true&"
import script from "./RadioVcDemo.vue?vue&type=script&lang=js&"
export * from "./RadioVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./RadioVcDemo.vue?vue&type=style&index=0&id=fc24e59e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc24e59e",
  null
  
)

export default component.exports